import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './MainContent.css';
import * as api from './services/api';
import LoadingSpinner from './components/LoadingSpinner';
import ErrorMessage from './components/ErrorMessage';

function MainContent() {
  const { t, i18n } = useTranslation();
  const [services, setServices] = useState([]);
  const [insights, setInsights] = useState([]);
  const [caseStudies, setCaseStudies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        // 获取所有服务
        const servicesData = await api.getServices();
        setServices(servicesData);

        // 获取精选洞察文章（前2篇）
        const insightsData = await api.getInsights({ featured: true });
        setInsights(insightsData.slice(0, 2));

        // 获取精选案例（前2个）
        const casesData = await api.getCaseStudies({ featured: true });
        setCaseStudies(casesData.slice(0, 2));

        setLoading(false);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to load content. Please try again later.');
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getCurrentLang = () => {
    return i18n.language === 'zh-CN' ? 'zh_CN' : 'en_US';
  };

  if (loading) {
    return (
      <main className="main-content">
        <LoadingSpinner />
      </main>
    );
  }

  if (error) {
    return (
      <main className="main-content">
        <ErrorMessage message={error} />
      </main>
    );
  }

  const lang = getCurrentLang();

  return (
    <main className="main-content">
      {/* 行业洞察板块 */}
      <section className="content-section insights-section">
        <div className="section-header">
          <h2>{t('mainContent.featuredInsights')}</h2>
          <a href="#insights" className="view-all-link" style={{ display: 'none' }}>{t('mainContent.viewAll')} →</a>
        </div>
        <div className="insights-grid">
          {insights.map((insight) => (
            <Link 
              key={insight.id} 
              to={`/insights/${insight.slug}`} 
              className="insight-card"
              style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
            >
              <div className="insight-image">
                <img src={insight.cover_image} alt={insight.title[lang]} />
                <span className="insight-category">featured insightadmin</span>
              </div>
              <div className="insight-content">
                <h3>{insight.title[lang]}</h3>
                <p className="insight-summary">{insight.summary[lang]}</p>
                <div className="insight-meta">
                  <span className="insight-author">{insight.author[lang]}</span>
                  <span className="insight-date">{insight.publish_date?.split('T')[0]}</span>
                  <span className="insight-read-time">
                    {insight.read_time} {t('common.time.minutes')}
                  </span>
                </div>
                <span className="read-more-link">
                  {t('mainContent.readMore')} →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* 成功案例板块 */}
      <section className="content-section cases-section">
        <div className="section-header">
          <h2>{t('mainContent.successStories')}</h2>
          <a href="#case-studies" className="view-all-link" style={{ display: 'none' }}>{t('mainContent.viewAll')} →</a>
        </div>
        <div className="cases-grid">
          {caseStudies.map((caseStudy) => (
            <Link 
              key={caseStudy.id} 
              to={`/case-studies/${caseStudy.slug}`} 
              className="case-card"
              style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
            >
              <div className="case-content">
                <span className="case-industry">{caseStudy.industry[lang]}</span>
                <h3>{caseStudy.client_name[lang]}</h3>
                <p className="case-challenge">{caseStudy.challenge[lang]}</p>
                <div className="case-results">
                  <ul>
                    {caseStudy.results.slice(0, 2).map((result, index) => (
                      <li key={index}>{result[lang]}</li>
                    ))}
                  </ul>
                </div>
                <span className="view-case-link">
                  {t('mainContent.readMore')} →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* 服务板块 - 已隐藏 */}
      {/* <section className="content-section services-section">
        <div className="section-header">
          <h2>{t('mainContent.ourServices')}</h2>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <Link 
              key={service.id} 
              to={`/services/${service.slug}`} 
              className="service-card"
              style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
            >
              <div className="service-content">
                <h3>{service.title[lang]}</h3>
                <p className="service-description">{service.short_description[lang]}</p>
                <span className="learn-more-link">
                  {t('mainContent.readMore')} →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section> */}
    </main>
  );
}

export default MainContent;
